// @flow
import * as React from 'react'
import MediaQuery from 'react-responsive'
import { BREAKPOINT } from './breakpoint'

type Props = {
  children: React.Node,
}

export default class DesktopMediaQuery extends React.Component<Props> {
  render = () => {
    return <MediaQuery minWidth={BREAKPOINT}>{this.props.children}</MediaQuery>
  }
}
